var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlog = function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.71 14.583V31.25H13.23a5.948 5.948 0 0 0-5.937 5.937V14.583c0-8.333 2.083-10.417 10.417-10.417h14.583c8.333 0 10.417 2.084 10.417 10.417Z",
    fill: "#EF940F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71 31.25v7.292c0 4.02-3.271 7.291-7.292 7.291H14.585c-4.021 0-7.292-3.27-7.292-7.291v-1.355a5.948 5.948 0 0 1 5.937-5.937h29.48ZM33.335 16.146H16.668a1.574 1.574 0 0 1-1.563-1.563c0-.854.709-1.562 1.563-1.562h16.667c.854 0 1.562.708 1.562 1.563 0 .854-.708 1.562-1.562 1.562ZM27.085 23.438H16.668a1.574 1.574 0 0 1-1.563-1.563c0-.854.709-1.563 1.563-1.563h10.417c.854 0 1.562.709 1.562 1.563s-.708 1.563-1.562 1.563Z",
    fill: "#EF940F"
  })));
};
export default SvgBlog;